import { render, staticRenderFns } from "./activityDatail.vue?vue&type=template&id=7781fa46&scoped=true&"
import script from "./activityDatail.vue?vue&type=script&lang=js&"
export * from "./activityDatail.vue?vue&type=script&lang=js&"
import style0 from "./activityDatail.vue?vue&type=style&index=0&id=7781fa46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7781fa46",
  null
  
)

export default component.exports